/* eslint-disable no-template-curly-in-string */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import GenericContent from '../../../../../components/CrudWithSteps/components/GenericContent';
import { CustomButton } from '../../../../../components/CustomButton';
import CustomTable from '../../../../../components/CustomTable/CustomTable';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import { Row } from '../../../../../components/Row';
import TooltipCaller from '../../../../../components/TooltipManager/TooltipCaller';
import { CONTRATO_EDIT_ETAPA_DADOS } from '../../../../../library/ContratoEditEtapas';
import {
  CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
  CONTRATO_STATUS_DESATIVADO,
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_ENCERRADO,
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_VIGENTE,
  CONTRATO_STATUS_AGUARDANDO_EXTRATO,
  CONTRATO_STATUS_APROVADO,
  CONTRATO_STATUS_NEGADO,
} from '../../../../../library/ContratoStatus';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../../library/ContratoVersoes';
import {
  contratoAditivoEditRoute,
  contratoAditivoNovoRoute,
  contratoDistratoEditRoute,
  contratoDistratoNovoRoute,
  contratoEditRoute,
} from '../../../../../library/Routes';
import { openModal } from '../../../../../store/modules/ModalActions';
import { getContratoTipoByRouteParams } from '../../../../../utils/ContratoUtils';
import { getElementID, getMergedClassNames } from '../../../../../utils/HTMLUtils';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import styles from './Arquivos.scss';
import AtivarButton from './arquivos/AtivarButton';
import DesativarButton from './arquivos/DesativarButton';
import DownloadNaoAssinadoButton from './arquivos/DownloadNaoAssinadoButton';
import UploadAssinadoButton from './arquivos/UploadAssinadoButton';
import DownloadAssinadoButton from './arquivos/DownloadAssinadoButton';
import DownloadExtratoButton from './arquivos/DownloadExtratoButton';
import UploadExtratoButton from './arquivos/UploadExtratoButton';
import { HelpButton } from '../../../../../components/HelpButton';
import UploadPlanoTrabalhoButton from './arquivos/UploadPlanoTrabalhoButton';
import DownloadPlanoTrabalhoButton from './arquivos/DownloadPlanoTrabalhoButton';
import { AddIcon } from 'assets/icons/AddIcon';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-ente-publico-arquivos';

const INITIAL_STATE = {
  sending: false,
  isMobile: false,
};

class Arquivos extends GenericContent {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  getActions = () => {
    return (
      <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-left'}
        >
          <CustomButton
            id={getElementID(rootElementId, '-criar-aditivo')}
            label={this.props.languageValues.cadastroContratoCriarAditivo}
            theme='pufvYellow'
            onClick={this.toNewAditivo}
            leftIcon={<AddIcon />}
            disabled={
              this.newAditivoIsDisabled() ||
              this.props.contratosEntePublico.loadingAlteraArquivo
            }
          />
        </Col>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-right'}
        >
          <CustomButton
            id={getElementID(rootElementId, '-criar-distrato')}
            label={this.props.languageValues.cadastroContratoCriarDistrato}
            theme='pufvYellow'
            onClick={this.toNewDistrato}
            rightIcon={<AddIcon />}
            disabled={
              this.newDistratoIsDisabled() ||
              this.props.contratosEntePublico.loadingAlteraArquivo
            }
          />
        </Col>
      </Row>
    );
  };

  toNewAditivo = () => {
    const idContrato =
      this.props.contratosEntePublico.contratoEditing.idContrato;
    const etapa = CONTRATO_EDIT_ETAPA_DADOS;
    this.props.history.push(
      contratoAditivoNovoRoute.getURLWithParams(
        getContratoTipoByRouteParams(this.props.match.params),
        idContrato,
        etapa
      )
    );
  };

  newAditivoIsDisabled = () => {
    if (!this.props.auth.userPermissions.contratos.entePublico.register) {
      return true;
    }
    const arquivos = this.props.contratosEntePublico.contratoEditing.arquivos;
    return arquivos && arquivos.geraAditivo ? false : true;
  };

  toNewDistrato = () => {
    const idContrato =
      this.props.contratosEntePublico.contratoEditing.idContrato;
    const etapa = CONTRATO_EDIT_ETAPA_DADOS;
    this.props.history.push(
      contratoDistratoNovoRoute.getURLWithParams(
        getContratoTipoByRouteParams(this.props.match.params),
        idContrato,
        etapa
      )
    );
  };

  newDistratoIsDisabled = () => {
    if (!this.props.auth.userPermissions.contratos.entePublico.register) {
      return true;
    }
    const arquivos = this.props.contratosEntePublico.contratoEditing.arquivos;
    return arquivos && arquivos.geraDistrato ? false : true;
  };

  getVersaoByVersaoNumero = (versaoNumero) => {
    return this.props.utils.getVersaoLabelByVersaoNumber(versaoNumero);
  };

  goToContratoUrl = (id, versaoContrato) => {
    let url = '';
    const etapa = CONTRATO_EDIT_ETAPA_DADOS;
    switch (versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        url = contratoAditivoEditRoute.getURLWithParams(
          getContratoTipoByRouteParams(this.props.match.params),
          this.props.contratosEntePublico.contratoEditing.idContrato,
          id,
          etapa
        );
        break;
      case CONTRATO_VERSAO_DISTRATO:
        url = contratoDistratoEditRoute.getURLWithParams(
          getContratoTipoByRouteParams(this.props.match.params),
          this.props.contratosEntePublico.contratoEditing.idContrato,
          id,
          etapa
        );
        break;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        url = contratoEditRoute.getURLWithParams(
          getContratoTipoByRouteParams(this.props.match.params),
          this.props.contratosEntePublico.contratoEditing.idContrato,
          etapa
        );
        break;
    }
    this.props.history.push(url);
  };

  getGoToButton = (arquivo, children, id) => {
    return (
      <>
        <TooltipCaller
          text={this.props.languageValues.cadastroContratoIrParaVersao
            .split('${1}')
            .join(this.getVersaoByVersaoNumero(arquivo.versaoContrato))}
        >
          <button
            className={!arquivo.ativo ? rootClassName + '-goto-disabled' : ''}
            id={id}
            onClick={() =>
              this.goToContratoUrl(arquivo.id, arquivo.versaoContrato)
            }
          >
            {children}
          </button>
        </TooltipCaller>
      </>
    );
  };

  getStatusLabel = (arquivo) => {
    let statusName = null;
    let flgStatus = arquivo.flgStatus;
    switch (arquivo.flgStatus) {
      case CONTRATO_STATUS_EM_EDICAO:
        statusName = this.props.languageValues.contratoStatusEmEdicao;
        break;
      case CONTRATO_STATUS_EM_ANALISE:
        statusName =
          this.props.languageValues.contratoStatusEmAnaliseOperacional;
        break;
      case CONTRATO_STATUS_AGUARDANDO_ASSINATURA:
        statusName =
          this.props.languageValues.contratoStatusAguardandoAssinatura;
        break;
      case CONTRATO_STATUS_NAO_INICIADO:
        statusName = this.props.languageValues.contratoStatusNaoIniciado;
        break;
      case CONTRATO_STATUS_VIGENTE:
        statusName = this.props.languageValues.contratoStatusVigente;
        break;
      case CONTRATO_STATUS_ENCERRADO:
        statusName = this.props.languageValues.contratoStatusEncerrado;
        break;
      case CONTRATO_STATUS_AGUARDANDO_EXTRATO:
        statusName = this.props.languageValues.contratoStatusExtrato;
        break;
      case CONTRATO_STATUS_APROVADO:
        statusName = this.props.languageValues.contratoStatusAprovado;
        break;
      case CONTRATO_STATUS_NEGADO:
        statusName = this.props.languageValues.contratoStatusRejeitado;
        break;
      case CONTRATO_STATUS_DESATIVADO:
      default:
        statusName = this.props.languageValues.contratoStatusDesativado;
        break;
    }
    return (
      <div
        className={getMergedClassNames([
          rootClassName + '-status-label',
          rootClassName + '-status-label-' + flgStatus,
        ])}
      >
        {statusName}
      </div>
    );
  };

  getAtivarButton = (arquivo) => {
    return (
      <AtivarButton
        id={rootElementId}
        arquivo={arquivo}
        refreshStep={this.props.refreshStep}
      />
    );
  };

  getDesativarButton = (arquivo) => {
    return (
      <DesativarButton
        id={rootElementId}
        arquivo={arquivo}
        refreshStep={this.props.refreshStep}
      />
    );
  };

  getDownloadNaoAssinadoButton = (arquivo) => {
    return (
      <DownloadNaoAssinadoButton
        id={rootElementId}
        arquivo={arquivo}
        refreshStep={this.props.refreshStep}
        utils={this.props.utils}
      />
    );
  };

  getUploadAssinadoButton = (arquivo) => {
    return (
      <UploadAssinadoButton
        id={rootElementId}
        arquivo={arquivo}
        refreshStep={this.props.refreshStep}
      />
    );
  };

  getDownloadAssinadoButton = (arquivo) => {
    return (
      <DownloadAssinadoButton
        id={rootElementId}
        arquivo={arquivo}
        refreshStep={this.props.refreshStep}
        utils={this.props.utils}
      />
    );
  };

  getUploadExtratoButton = (arquivo) => {
    return (
      <UploadExtratoButton
        id={rootElementId}
        arquivo={arquivo}
        refreshStep={this.props.refreshStep}
      />
    );
  };

  getDownloadExtratoButton = (arquivo) => {
    return (
      <DownloadExtratoButton
        id={rootElementId}
        arquivo={arquivo}
        refreshStep={this.props.refreshStep}
        utils={this.props.utils}
      />
    );
  };

  getUploadPlanoTrabalhoButton = (arquivo) => {
    return (
      <UploadPlanoTrabalhoButton
        id={rootElementId}
        arquivo={arquivo}
        refreshStep={this.props.refreshStep}
      />
    );
  };

  getDownloadPlanoTrabalhoButton = (arquivo) => {
    return (
      <DownloadPlanoTrabalhoButton
        id={rootElementId}
        arquivo={arquivo}
        refreshStep={this.props.refreshStep}
        utils={this.props.utils}
      />
    );
  };

  getTableRow = (arquivo) => {
    return {
      columns: [
        {
          value: this.getGoToButton(
            arquivo,
            arquivo.codigo,
            getElementID(rootElementId, 'versao-' + arquivo.id)
          ),
          props: {
            className: rootClassName + '-td',
          },
        },
        {
          value: this.getGoToButton(
            arquivo,
            this.getVersaoByVersaoNumero(arquivo.versaoContrato),
            getElementID(rootElementId, 'versao-' + arquivo.id)
          ),
          props: {
            className: rootClassName + '-td',
          },
        },
        {
          value: this.getStatusLabel(arquivo),
          props: {
            className: rootClassName + '-td',
          },
        },
        {
          value: (
            <>
              {this.getAtivarButton(arquivo)}
              {this.getDesativarButton(arquivo)}
              {this.getDownloadNaoAssinadoButton(arquivo)}
              {this.getUploadAssinadoButton(arquivo)}
              {this.getDownloadAssinadoButton(arquivo)}
              {this.getUploadExtratoButton(arquivo)}
              {this.getDownloadExtratoButton(arquivo)}
              {this.getUploadPlanoTrabalhoButton(arquivo)}
              {this.getDownloadPlanoTrabalhoButton(arquivo)}
            </>
          ),
          props: {
            className: rootClassName + '-td-actions',
          },
        },
      ],
    };
  };

  getAdendos = () => {
    const arquivos = {
      ...this.props.contratosEntePublico.contratoEditing.arquivos,
    };
    if (arquivos && arquivos.adendos) {
      const adendos = arquivos.adendos.map((item) => {
        return {
          ...item,
          order: Number(item.versaoContrato + '.' + item.id),
        };
      });
      return adendos;
    }
    return [];
  };

  getTableRows = () => {
    const adendos = this.getAdendos();
    let lines = [];
    adendos.map((arquivo, index) => {
      lines.push(
        this.getTableRow({
          ...arquivo,
          isLatest: index >= adendos.length - 1,
        })
      );
      return index;
    });
    return lines;
  };

  getCustomTableProps = () => {
    return {
      lockReorder: true,
      columns: [
        {
          name: this.props.languageValues.cadastroContratoArquivosColumnCodigo,
        },
        {
          name: this.props.languageValues.cadastroContratoArquivosColumnVersao,
        },
        {
          name: this.props.languageValues
            .cadastroContratoArquivosColumnSituacao,
        },
        {
          name: this.props.languageValues.cadastroContratoArquivosColumnAcoes,
          props: {
            className: rootClassName + '-th-actions',
          },
        },
      ],
      lines: this.getTableRows(),
    };
  };

  getTitle = () => {
    return (
      <CardTitle onClick={this.openStepsMenu}>
        {this.props.languageValues.cadastroContratoArquivos}{' '}
        <HelpButton
          text={this.props.languageValues.arquiviosEntePublicoHint}
          className={rootClassName + '-title-hint'}
        />
      </CardTitle>
    );
  };

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: this.getTitle(),
        actions: this.getActions(),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending:
          this.props.loading ||
          this.state.sending ||
          this.props.contratosEntePublico.loadingArquivos,
      },
    };
  };

  updateDimensions = () => {
    this.setState({
      ...this.state,
      isMobile: window.innerWidth < parseInt(styles.mdSize) ? true : false,
    });
  };

  UNSAFE_componentWillMount() {
    this.updateDimensions();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  getMobileItems = () => {
    const adendos = this.getAdendos();
    return adendos.map((arquivo, index) => {
      const newArquivo = {
        ...arquivo,
        isLatest: index >= adendos.length - 1,
      };
      return (
        <div className={rootClassName + '-item'} key={index}>
          <div
            className={getMergedClassNames([
              rootClassName + '-item-text',
              !newArquivo.ativo ? rootClassName + '-item-text-disabled' : '',
            ])}
            onClick={() =>
              this.goToContratoUrl(arquivo.id, arquivo.versaoContrato)
            }
          >
            {newArquivo.codigo +
              ' - ' +
              this.getVersaoByVersaoNumero(newArquivo.versaoContrato)}
            <br />
            {this.getStatusLabel(newArquivo)}
          </div>
          <div className={rootClassName + '-item-actions'}>
            {this.getAtivarButton(newArquivo)}
            {this.getDesativarButton(newArquivo)}
            {this.getDownloadNaoAssinadoButton(newArquivo)}
            {this.getUploadAssinadoButton(newArquivo)}
            {this.getDownloadAssinadoButton(newArquivo)}
            {this.getUploadExtratoButton(newArquivo)}
            {this.getDownloadExtratoButton(newArquivo)}
            {this.getUploadPlanoTrabalhoButton(newArquivo)}
            {this.getDownloadPlanoTrabalhoButton(newArquivo)}
          </div>
        </div>
      );
    });
  };

  getTable = () => {
    return this.state.isMobile ? (
      <div>{this.getMobileItems()}</div>
    ) : (
      <CustomTable {...this.getCustomTableProps()} />
    );
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            {this.props.loading ||
            this.state.sending ||
            this.props.contratosEntePublico.loadingArquivos ||
            !this.props.contratosEntePublico.contratoEditing.arquivos
              ? this.props.languageValues.loadingArquivos
              : this.getTable()}
          </Col>
        </Row>
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            {this.props.loading ||
            this.state.sending ||
            this.props.contratosEntePublico.loadingArquivos ||
            !this.props.contratosEntePublico.contratoEditing.arquivos
              ? ''
              : this.props.languageValues
                  .arquiviosEntePublicoPlanoTrabalhoHintBaixo}
          </Col>
        </Row>
      </GenericCardScreen>
    );
  }
}

Arquivos.propTypes = {
  utils: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  editing: PropTypes.bool,
  refreshStep: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosEntePublico: state.contratosEntePublico,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Arquivos));
